<div fxLayout="row wrap" fxLayoutAlign="space-evenly none" class="unauthorised-container">
  <div class="error">
    Unfortunately your account type (<span>{{accountType}}</span>) is not authorised to access this site.
  </div>
</div>
